var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.52344,
    y: 2.95312,
    width: 20.9524,
    height: 19.0476,
    rx: 4,
    fill: "#A3B0B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31844 17.7128V17.0516C6.31844 14.9527 9.74696 13.7144 9.74696 12.3606C9.74696 11.8149 9.36971 11.458 8.74836 11.458C8.11592 11.458 7.79415 11.8568 7.64991 12.3186L6.28516 11.9408C6.46268 11.2062 7.12842 10.0938 8.81494 10.0938C10.3128 10.0938 11.3447 10.9543 11.3447 12.2976C11.3447 14.2706 8.44879 15.2151 8.1714 16.2855H11.4335V17.7128H6.31844Z",
    fill: "url(#paint0_radial_3633_3687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9731 17.7128C13.3199 17.7128 12.2547 16.8208 12.2547 15.4145C12.2547 14.512 12.8317 13.9243 13.3199 13.6724C12.9426 13.4415 12.4655 12.9273 12.4655 12.1822C12.4655 10.9753 13.453 10.0938 14.9842 10.0938C16.5043 10.0938 17.5029 10.9648 17.5029 12.1822C17.5029 12.9273 17.0258 13.4415 16.6375 13.6724C17.1479 13.9348 17.7137 14.512 17.7137 15.4145C17.7137 16.8103 16.6153 17.7128 14.9731 17.7128ZM14.9842 14.407C14.2963 14.407 13.8525 14.8163 13.8525 15.3935C13.8525 15.9392 14.2519 16.3695 14.9842 16.3695C15.7276 16.3695 16.116 15.9392 16.116 15.3935C16.116 14.8163 15.6722 14.407 14.9842 14.407ZM14.9842 11.4266C14.3518 11.4266 14.0189 11.8044 14.0189 12.2661C14.0189 12.7699 14.4073 13.1162 14.9842 13.1162C15.5501 13.1162 15.9495 12.7699 15.9495 12.2661C15.9495 11.8044 15.6056 11.4266 14.9842 11.4266Z",
    fill: "url(#paint1_radial_3633_3687)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52344 6.76265C1.52344 4.65871 3.22902 2.95312 5.33296 2.95312H18.6663C20.7702 2.95312 22.4758 4.65871 22.4758 6.76265H1.52344Z",
    fill: "#D2D2D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23828 2V4.85714",
    stroke: "url(#paint2_radial_3633_3687)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7617 2V4.85714",
    stroke: "url(#paint3_radial_3633_3687)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3633_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50626 8.10385) rotate(90) scale(10.9451 11.5157)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3633_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.50626 8.10385) rotate(90) scale(10.9451 11.5157)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3633_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.52013 1.25379) rotate(90) scale(4.10442 1.00762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3633_3687",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0436 1.25379) rotate(90) scale(4.10442 1.00762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#E4E4E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.9fd2c33aac406a478c0619e6593743bb.svg";
export { ForwardRef as ReactComponent };